<div class="warp-data">
    <div class="header">
        <div class="warp-right">
            <svg-icon svgClass="svg-img return pointer scale-img" (click)="return()"
                src="/assets/images/data/return.svg"></svg-icon>
            <img src="/assets/images/data/restore-page.svg">
            <div class="warp-name">
                <p class="name">{{name$()}}</p>
                <p class="date" *ngIf="date$()">{{date$() | queDate}}</p>
            </div>
        </div>
        <div class="export" [ngClass]="{'disabled':loadingData$(), 'pointer':!loadingData$()}"
            (click)="loadingData$()?null:exportReport()">
            <img class="point-img" src="/assets/images/export/export-report.svg">
            <img class="disabl-img" src="/assets/images/export/export-report-disable.svg">
            <span translate>data.export.title</span>
            <img class="point-img" src="/assets/images/export/arrow-down.svg">
            <img class="disabl-img" src="/assets/images/export/arrow-down-disable.svg">
        </div>
    </div>
    <div class="wrapper">
        <div class="nav">
            <div class="options-title" translate>
                data.comments
            </div>
            <div>
                <div class="nav-item hover-with-grediant"
                    [ngClass]="{'select select-with-grediant':displayState$()=='answeredTheQuestionnaire'}"
                    (click)="navToAnswered()" translate>data.answered
                </div>
                <div class="nav-item hover-with-grediant"
                    [ngClass]="{'select select-with-grediant':displayState$()=='summary'}" (click)="navToSummary()"
                    translate>data.summary.title
                </div>
                <div class="nav-item hover-with-grediant"
                    [ngClass]="{'select select-with-grediant':displayState$()=='submissions'}"
                    (click)="navToSubmissions()" translate>data.submissions.title
                </div>
                <div class="nav-item hover-with-grediant" *ngIf="apiExposureEnabled"
                    [ngClass]="{'select select-with-grediant':displayState$()=='apiExposure'}"
                    (click)="navToApiExposure()" translate>data.apiExposure.title
                </div>
            </div>
            <ng-container *ngIf="displayState$()!='answeredTheQuestionnaire' && displayState$()!='apiExposure'">
                <div class="options-title top" translate>
                    menuTypes.stepsTitle
                </div>
                <div class="warp-stepper">
                    <que-stepper *ngIf="stepsNames$()" [stepsNames]="stepsNames$()!" [currentStep]=" currentStep$()"
                        [isData]="true" (ChangeStepEvent)="changePage($event)"></que-stepper>
                </div>
            </ng-container>
        </div>
        <div class="warp-router-outlet">
            <div class="pagination"  *ngIf="isDataForAllSig$() && displayState$()!='answeredTheQuestionnaire' && displayState$()!='apiExposure'">
                <que-data-toolbar
                    [fromSummary]="displayState$()=='summary'"></que-data-toolbar>
            </div>
                <router-outlet></router-outlet>
        </div>
    </div>
</div>